const mediaConfig = {
  '@media only screen and (max-width: 1365px)': {
    maxWidth: 'max(calc(100vw - 984px), 180px)',
  },
  '@media only screen and (max-width: 1023px)': {
    maxWidth: 'max(calc(100vw - 784px), 180px)',
  },
  '@media only screen and (min-width: 1366px)': {
    maxWidth: 'max(calc(100vw - 1202px), 180px)',
  },
};

export const getEntityBreadcrumbStyles = (_, { palette = {} }) => ({
  container: {
    '&:hover': {
      backgroundColor: palette.themeDarkAlt,
      '& .breadcrumb-container .breadcrumb': {
        backgroundColor: palette.themeDarkAlt,
      },
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  main: {
    '& .breadcrumb-container .breadcrumb': {
      backgroundColor: palette.globalBackground,
      height: 16,
      marginTop: 10,
      marginBottom: 0,
      '& .breadcrumb-item-text': {
        color: palette.white,
        fontSize: '12px',
        '&:hover': {
          textDecoration: 'underline',
        },
        ...mediaConfig,
      },
      '& .chevron-right-icon': {
        color: palette.white,
      },
      '& .clickable-item:hover': {
        backgroundColor: palette.themeDarkAlt,
      },
    },
  },
  sub: {
    '& .breadcrumb-container .breadcrumb': {
      backgroundColor: palette.globalBackground,
      height: 19,
      marginBottom: 10,
      marginTop: 5,
      '& .breadcrumb-item-text': {
        color: palette.white,
        fontSize: '14px',
        fontWeight: 600,
        '&:hover': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        ...mediaConfig,
      },
      '& .clickable-item:hover': {
        backgroundColor: palette.themeDarkAlt,
      },
    },
  },
});
